import { defineStore } from 'pinia';
import config from './config';

export default storeName => defineStore(storeName, config);

